import React, { useState, useEffect, useCallback } from "react";
import "../../../stylesheet/forms.css";
import { RxCross1 } from "react-icons/rx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";
// import { BsThreeDotsVertical } from "react-icons/bs";
import Dropdown from "./Dropdown";

const Drugs = ({ formData, updateFormData, mode }) => {
  const [editingMode, setEditingMode] = useState(false);
  const [isDataInputted, setIsDataInputted] = useState(false);
  const [drugIndex, setDrugIndex] = useState(-1);
  const [drugs, setDrugs] = useState(mode? [] : [...formData]);
  const [isAddingDrug, setisAddingDrug] = useState(false);
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [currentDrug, setCurrentDrug] = useState({
    med_name: "",
    description: "",
    startDate: "",
    endDate: "",
    recommendedDosage: "",
    intakeQuantity: "",
    intakeMeasurement: "",
    consumptionFrequency: "",
    mealTiming: "",
    isSelected: false
  });
  const [allDrugsSelected, setAllDrugsSelection] = useState(false)
  const [drugItems, setDrugItems] = useState([]);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentDrug((prevState) => ({
      ...prevState,
      [name]: name === "startDate" || name === "endDate" ? new Date(value) : value, [name]: value,
    }));
    setIsDataInputted(true);
    if (mode !== 'direct') {
      updateFormData({
        drugs: [...drugs, currentDrug],
      })
    }

  };
  const handleSaveDrug = () => {
    setDrugs((prevDrugs) => [...prevDrugs, currentDrug]);
    setCurrentDrug({
      med_name: "",
      description: "",
      startDate: "",
      endDate: "",
      recommendedDosage: "",
      intakeQuantity: "",
      intakeMeasurement: "",
      consumptionFrequency: "",
      mealTiming: "",
      isSelected: false
    });
    setisAddingDrug(false)
  };
  const [showEnteredDrugDetails, setShowEnteredDrugDetails] = useState(false);
  const handleSaveEditedDrug = () => {
    const updatedDrugs = [...drugs];
    updatedDrugs[drugIndex] = currentDrug; // Update the drug in the array
    setDrugs(updatedDrugs);
    setDrugIndex(-1); // Reset currentDrugIndex
    setCurrentDrug({
      med_name: "",
      description: "",
      startDate: "",
      endDate: "",
      recommendedDosage: "",
      intakeQuantity: "",
      intakeMeasurement: "",
      consumptionFrequency: "",
      mealTiming: "",
      isSelected: false
    });
    setEditingMode(false);
    setIsDataInputted(false);
  };

  const addNewDrugItem = (newDrugItem) => {
    setDrugItems([...drugItems, newDrugItem]); // Add the new item to the array
  };
  const handleSaveDrugClick = (e) => {
    e.preventDefault()
    addNewDrugItem(currentDrug)
    if (
      currentDrug.med_name &&
      currentDrug.description &&
      currentDrug.startDate &&
      currentDrug.endDate &&
      currentDrug.recommendedDosage &&
      currentDrug.intakeQuantity &&
      currentDrug.intakeMeasurement &&
      currentDrug.consumptionFrequency &&
      currentDrug.mealTiming
    ) {
      if (editingMode) {
        handleSaveEditedDrug(); // Call the function to save edited drug

      } else {
        handleSaveDrug(); // Call the function to save new drug
      }
      setShowEnteredDrugDetails(true);
      setIsDataInputted(false);
      setEditingMode(false); // Exit editing mode
      setDrugIndex(-1); // Clear editing index
      setCurrentDrug({
        med_name: "",
        description: "",
        startDate: "",
        endDate: "",
        recommendedDosage: "",
        intakeQuantity: "",
        intakeMeasurement: "",
        consumptionFrequency: "",
        mealTiming: "",
        isSelected: false
      });
      setisAddingDrug(false)
    } else {
      alert("Please fill out all required fields");
    }
  };
  const resetInputFields = () => {
    setCurrentDrug({
      med_name: "",
      description: "",
      startDate: "",
      endDate: "",
      recommendedDosage: "",
      intakeQuantity: "",
      intakeMeasurement: "",
      consumptionFrequency: "",
      mealTiming: "",
      isSelected: false
    });
  };
  const CustomInput = ({ value, onClick }) => (
    <div className="custom-input" onClick={onClick}>
      {value ? value : <span className="placeholder">DD/MM/YYYY</span>}
      <FiCalendar className="calendar-icon" />
    </div>
  );
  const deleteSelected = (e) => {
    const newArr = selectedDrugs
    const newDrugs = drugs
    selectedDrugs.forEach((item) => {
      const foundId = newDrugs.findIndex(({ med_name }) => med_name == item.med_name)
      newDrugs.splice(foundId, 1)
      setDrugs(newDrugs)
    })
    setSelectedDrugs([])
  }

  const isSelected = (e) => {
    const foundDrug = selectedDrugs.find(({ isSelected }) => e.target.data.isSelected == isSelected)
    return foundDrug.isSelected
  }
  const selectAllDrugs = (e) => {
    const newArr = drugs
    if (e.target.checked) {
      newArr.map(item => item.isSelected = true)
      setSelectedDrugs(newArr)
      setDrugs(newArr)
    } else {
      newArr.map(item => item.isSelected = false)
      setDrugs(newArr)
      setSelectedDrugs([])
      setAllDrugsSelection(false)
    }
  }

  const selectDrugFromTable = (e) => {
    const foundDrug = drugs.find((item, itemIndex) => itemIndex == e.target.id)
    if (!e.target?.checked) {
      foundDrug.isSelected = false
      const newArr = selectedDrugs
      newArr.splice(e.target.id, 1)
      setSelectedDrugs([...newArr])
    } else {
      foundDrug.isSelected = true
      setSelectedDrugs([...selectedDrugs, foundDrug])
    }
  };

  const handleEditDrug = (index) => {
    const updatedDrugs = [...drugs]
    updatedDrugs.splice(index, 1)
    setDrugs(updatedDrugs);
  };

  const handleEditInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedDrugs = [...drugs];
    updatedDrugs[index][name] = value;
    setDrugs(updatedDrugs);
  };
  const updateDrugDetails = () => {
    updateFormData(drugs)
    setisAddingDrug(false)
  }
  // setisAddingDrug(true)
  // useEffect(() =>
  // {
  //   if (mode) {
      
  //   }
  // }, [])
  return (
    <div className="drugs">
      {
        !isAddingDrug ?
          <div className="w-full flex justify-end px-6 my-6">
            <button onClick={(e) => { e.preventDefault(); setisAddingDrug(true) }} className="text-white h-[42px] px-3 pt-1 pb-[3px] rounded-[10px] justify-center items-center inline-flex bg-[#009fe3] text-center p-2 cursor-point text-base font-medium leading-[34.53px] tracking-wide">Add New Drug</button>
          </div>
          :
          <div className="step_form">
            <div className="step_input">
              <label htmlFor="med_name">Add a medication </label>
              <input
                id="med_name"
                name="med_name"
                type="text"
                placeholder="Enter medication name"
                value={currentDrug.med_name}
                onChange={handleInputChange}
              />
            </div>

            <div className="step_input">
              <label htmlFor="description">Description</label>
              <textarea
                placeholder="Enter a Description..."
                name="description"
                id="description"
                rows="7"
                value={currentDrug.description}
                onChange={handleInputChange}
              ></textarea>
            </div>

            <div className="step_doubles">
              <div className="step_inputs">
                <label htmlFor="start_date">Start Date</label>
                <DatePicker
                  id="startDate"
                  selected={currentDrug.startDate}
                  onChange={(date) =>
                    handleInputChange({
                      target: { name: "startDate", value: date },
                    })
                  }
                  dateFormat="dd/MM/yyyy"
                  customInput={<CustomInput />}
                  placeholderText="DD/MM/YYYY"
                  isClearable
                />
              </div>

              <div className="step_inputs">
                <label htmlFor="end_date">End Date</label>
                <DatePicker
                  id="endDate"
                  selected={currentDrug.endDate}
                  onChange={(date) =>
                    handleInputChange({ target: { name: "endDate", value: date } })
                  }
                  dateFormat="dd/MM/yyyy"
                  placeholderText="DD/MM/YYYY"
                  customInput={<CustomInput />}
                  isClearable
                />
              </div>
            </div>

            {/* <div className="step_input">
              <div> <label htmlFor="recommendedDosage">Recommended dosage</label></div>
              <input
                id="recommendedDosage"

                type="number"
                placeholder="Enter recommended dosage" value={currentDrug.intakeQuantity}
                name="intakeQuantity"
                onChange={handleInputChange}
                inputMode="numeric"
                min={0}
                pattern="[0-9]*"
              />
            </div> */}
            <div className="w-full flex justify-between gap-6">
              <div className="w-1/2">
                <div><label htmlFor="recommendedDosage">Recommended Dosage Strenght of Drug</label></div>
                <input
                  id="recommendedDosage"
                  className="w-full border rounded-md p-3"
                  type="number"
                  placeholder="Enter recommended dosage" value={currentDrug.intakeQuantity}
                  name="intakeQuantity"
                  onChange={handleInputChange}
                  inputMode="numeric"
                  min={0}
                  pattern="[0-9]*"
                />
              </div>
              <div className="w-1/2">
                <label htmlFor="intakeQuantityMeasurement">Recommended Dosage measurement unit</label>
                <select
                  name="intakeQuantityMeasurement"
                  id="intake_q_measurement"
                  className="w-full"
                  aria-label="Select unit"
                  value={currentDrug.intakeQuantityMeasurement}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select unit
                  </option>
                  <option value="ml">Ml</option>
                  <option value="mg">Mg</option>
                  <option value="teaspoon">Teaspoon</option>
                  <option value="drop">Drop(s)</option>
                  <option value="capsule">Capsule</option>
                  <option value="suppository">Suppository</option>
                  <option value="puff">Puff(s)</option>
                </select>
              </div>
            </div>

            <div className="step_doubles">
              <div className="step_inputs">
                <label htmlFor="intake_quantity">Intake quantity</label>
                <input
                  type="number"
                  id="intake_quantity"
                  placeholder="Enter number"
                  inputMode="numeric"
                  min={0}
                  pattern="[0-9]*"
                  name="recommendedDosage"
                  value={currentDrug.recommendedDosage}
                  onChange={handleInputChange}
                />
              </div>

              <div className="step_inputs">
                <label htmlFor="intakeMeasurement">Intake measurement unit</label>
                <select
                  name="intakeMeasurement"
                  id="intake_measurement"
                  aria-label="Select unit"
                  value={currentDrug.intakeMeasurement}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select unit
                  </option>
                  <option value="ml">Ml</option>
                  <option value="mg">Mg</option>
                  <option value="teaspoon">Teaspoon</option>
                  <option value="drop">Drop(s)</option>
                  <option value="capsule">Capsule</option>
                  <option value="suppository">Suppository</option>
                  <option value="puff">Puff(s)</option>
                </select>
              </div>
            </div>


            <div className="w-full flex justify-between gap-6">
              <div className="w-1/2">
                <label htmlFor="consumptionFrequency">Consumption frequency</label>
                <select
                  className="w-full"
                  name="consumptionFrequency"
                  id="consumption_frequency"
                  aria-label="Select frequency"
                  value={currentDrug.consumptionFrequency}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select Consumption frequency
                  </option>
                  <option value="every_30_minutes">Every 30 minutes</option>
                  <option value="hourly">Hourly</option>
                  <option value="6_hours">Every 6 hours</option>
                  <option value="every_12_hours">Every 12 hours</option>
                  <option value="daily">Daily</option>
                  <option value="2_days">Every 2 days</option>
                </select>
              </div>
              <div className="w-1/2">
                <label htmlFor="mealTiming">Meal timing</label>
                <select
                  className="w-full"
                  name="mealTiming"
                  id="mealTiming"
                  aria-label="Select meal timing"
                  value={currentDrug.mealTiming}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select meal timing
                  </option>
                  <option value="before_meal">Take before meal</option>
                  <option value="after_meal">Take after meal</option>
                </select>
              </div>
            </div>
            <div>
            </div>

            <div className="drug_btn">
              <button type="button" onClick={resetInputFields} className={[`remov ${isDataInputted ? 'active' : ''}`]} >
                <RxCross1 />
                Remove
              </button>
              <button type="button" onClick={handleSaveDrugClick} className={`save-btn ${isDataInputted ? 'active' : ''}`} disabled={!isDataInputted} >
                Save drug detail{" "}
              </button>

            </div>
            {drugs.length ?
              <div className="text-sm opacity-70 font-light my-5"> <span>
                {drugs.length === 1
                  ? "1 Drug Added"
                  : `${drugs.length} Drugs Added`}
              </span></div>
              : null}
          </div>
      }
      {drugs.length ? (
        <div className="entered-drugs px-6">
          <table className="drug_table">
            <thead>
              <tr>
                {/* <th className="check"></th> */}
                <th>
                  <div className="flex">
                    <div>
                      {/* onChange={selectAllDrugs} */}
                      <input type="checkbox" onChange={selectAllDrugs} defaultChecked={allDrugsSelected} />
                    </div>
                    <span className="ml-4">

                      S/N
                    </span>
                  </div>
                </th>
                <th> <div>Drug Name</div>  </th>
                <th>Dosage</th>
                <th>
                  <div className="text-right">
                    {
                      selectedDrugs.length > 0 ?
                        <button type="button" className={`bg-red-600 text-sm text-white p-[0.4rem] rounded-md ${drugs.length}`} disabled={!drugs.length} onClick={deleteSelected} >
                          Delete Selected{" "}
                        </button>
                        : null
                    }
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {drugs.map((drug, index) => (
                <tr className="p-4" key={index}>
                  <td className="p-4">
                    <div className="flex items-center align-middle">
                      <input type="checkbox" id={`${index}`} data={drug} data-ref={drug.isSelected}
                        onChange={selectDrugFromTable}
                        defaultValue={isSelected} checked={drug.isSelected}
                      />
                      <div className="ml-4">
                        #{index + 1}
                      </div>
                    </div>
                  </td>
                  <td className="p-4">{drug.med_name}</td>
                  <td className="dos p-4">{`${drug.intakeQuantity}`} {drug.intakeMeasurement} - {`${drug.consumptionFrequency}`}</td>
                  <td className="p-4">
                    <Dropdown setedit={setEditingMode} className="text-right" data={index} drugsData={drugs} setDrugsData={setDrugs} curr={currentDrug} setCurr={setCurrentDrug} setindex={setDrugIndex} setisAddingDrug={setisAddingDrug} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {
            mode === 'direct' &&
            <div className="my-10 w-full">
              <div>
                <div className="w-full flex justify-end">
                  <button onClick={updateDrugDetails()} className="text-white h-[42px] px-3 pt-1 pb-[3px] rounded-[10px] justify-center items-center inline-flex bg-[#009fe3] text-center p-2 cursor-point text-base font-medium leading-[34.53px] tracking-wide">Continue</button>
                </div>
              </div>
            </div>
          }
        </div>
      ) :
        <>
          <div className="my-10 w-full text-center">
            <span className="italic opacity-55 ">
              No drugs added yet, please click "Add new drug" to create.
            </span>
          </div>
        </>
      }
    </div>
  );
};

export default Drugs;
